import { css } from 'styled-components';
import { makeAutoObservable } from 'mobx';

const COLORS_V2 = {
  SHADES: {
    0: '#FFFFFF',
    100: '#000000',
  },
  NEUTRAL: {
    50: '#FAF9F9',
    100: '#EFEEEE',
    200: '#DEDDDC',
    300: '#CECDCB',
    400: '#BEBCBA',
    500: '#928F8C',
    600: '#807D7A',
    700: '#5C5957',
    800: '#373634',
    900: '#121211',
  },
  PRIMARY: {
    50: '#FAF9F8',
    100: '#F1EDEB',
    200: '#E4DCD7',
    300: '#D6CAC4',
    400: '#C8B9B0',
    500: '#A48A7B',
    600: '#957766',
    700: '#6A5549',
    800: '#40332C',
    900: '#15110F',
  },
  SECONDARY: {
    50: '#FCFAF7',
    100: '#F2EBDE',
    200: '#E5D6BD',
    300: '#D9C29B',
    400: '#CCAD7A',
    500: '#BF9959',
    600: '#B18844',
    700: '#7E6131',
    800: '#4C3A1D',
    900: '#19130A',
    1000: '#78480F',
  },
  SUCCESS: {
    50: '#F9FDFA',
    100: '#EDF9EF',
    200: '#D6F0D9',
    300: '#BFE7C3',
    400: '#A7DFAD',
    500: '#83D28C',
    600: '#41B34D',
    700: '#22763D',
    800: '#276B2E',
    900: '#0D240F',
  },
  WARNING: {
    50: '#FFFBF8',
    100: '#FDF4EB',
    200: '#FCE5D1',
    300: '#FAD7B7',
    400: '#F8C89D',
    500: '#F6BA83',
    600: '#F3A257',
    700: '#DC7110',
    800: '#84440A',
    900: '#2C1703',
  },
  DESTRUCTIVE: {
    50: '#FEF8F8',
    100: '#FBEBEB',
    200: '#F5D0D0',
    300: '#EFB6B6',
    400: '#E99B9B',
    500: '#E38181',
    600: '#DB5D5D',
    700: '#B62828',
    800: '#6D1818',
    900: '#240808',
  },
};

class ThemeStore {
  colors = COLORS_V2;

  webText = {
    headerOne: css`
       font-family: 'GenWanMin';
       font-size: 56px;
       font-weight: 600;
       line-height: 112px;
       letter-spacing: 0.03em;
      `,
    headerTwo: css`
       font-family: 'GenWanMin';
       font-size: 32px;
       font-weight: 600;
       line-height: 80px;
       letter-spacing: 0.03em;
      `,
    title: css`
       font-family: 'GenWanMin';
       font-size: 24px;
       font-weight: 600;
       line-height: 48px;
       letter-spacing: 0.03em;
      `,
    subtitle: css`
        font-family: 'GenWanMin';
        font-size: 18px;
        font-weight: 600;
        line-height: 36px;
        letter-spacing: 0.03em;
      `,
    bodyRegular: css`
        font-family: 'Noto Sans TC';
        font-size: 16px;
        font-weight: 300;
        line-height: 32px;
        letter-spacing: 0.03em;
      `,
    preTitleMedium: css`
      font-family: 'Noto Sans TC';
        font-size: 14px;
        font-weight: 350;
        line-height: 18px;
        letter-spacing: 0.03em;
      `,
    preTitleRegular: css`
        font-family: 'Noto Sans TC';
        font-size: 14px;
        line-height: 18px;
        font-weight: 300;
        letter-spacing: 0.03em;
      `,
    preTitleUpper: css`
      font-family: 'Noto Sans TC';
      font-size: 13px;
      font-weight: 300;
      line-height: 16px;
      letter-spacing: 0.03em;
      text-decoration: 'uppercase';
    `,
  }

  mobileText = {
    headerOne: css`
       font-family: 'GenWanMin';
       font-size: 32px;
       font-weight: 600;
       line-height: 40px;
       letter-spacing: 0.03em;
      `,
    headerTwo: css`
       font-family: 'GenWanMin';
       font-weight: 600;
       line-height: 68px;
       letter-spacing: 0.03em;
       text-align: left;
       font-size: 20px;
      `,
    title: css`
       font-family: 'GenWanMin';
       font-size: 24px;
       font-weight: 600;
       line-height: 68px;
       letter-spacing: 0.03em;
       text-align: left;
      `,
    subtitle: css`
        font-family: 'GenWanMin';
        font-size: 16px;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 0.03em;
      `,
    bodyRegular: css`
        font-family: 'Noto Sans TC';
        font-size: 16px;
        font-weight: 400;
        line-height: 32px;
        letter-spacing: 0.03em;
      `,
    bodyDemiLight: css`
        font-size: 16px;
        font-family: 'Noto Sans TC';
        font-weight: 350;
        line-height: 24px;
        letter-spacing: 0.03em;
      `,
    preTitleDemiLight: css`
        font-family: 'Noto Sans TC';
        font-size: 14px;
        font-weight: 350;
        line-height: 21px;
        letter-spacing: 0.03em;
      `,
    preTitleLight: css`
        font-family: 'Noto Sans TC';
        font-weight: 300;
        line-height: 21px;
        letter-spacing: 0.03em;
        font-size: 14px;
    `,
    preTitleUpper: css`
        font-family: 'Noto Sans TC';
        font-size: 12px;
        font-weight: 300;
        line-height: 15px;
        letter-spacing: 0.03em;
      `,
  }

  constructor() {
    makeAutoObservable(this);
  }
}

export const themeStore = new ThemeStore();
